// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zUoLj","background":"styles_background__rrAya","content":"styles_content__p1awr"};